import React from 'react'

import { connect } from 'react-redux'
import { fetchCustomer } from '../../actions/customer-actions'
import { upsertGroup, removeGroup } from '../../actions/group-actions'
import { Grid, Row, Table } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import { isEmpty, orderBy } from 'lodash'
import 'react-toggle/style.css'

import Breadcrumbs from '../../components/Breadcrumbs'
import SearchBar from '../../components/SearchBar'
import PropertyTitle from '../../components/PropertyTitle'
import Property from '../../components/Property'
import LicenseTable from '../../components/LicenseTable'
import NotFound from '../NotFound'
import ConfirmHandleResponseModal from '../../components/ConfirmHandleResponseModal'
import GroupModal from '../../components/GroupModal'
import NotesOverview from '../../components/NotesOverview'

class CustomerDetail extends React.Component {
  constructor() {
    super()
    this.state = { showDeleted: false }
  }

  componentDidMount() {
    this.reload()
  }

  componentDidUpdate(oldProps) {
    if (this.props.match.params.id !== oldProps.match.params.id) {
      this.props.fetchCustomer(this.match.params.id)
    }
  }

  upsertGroup(group) {
    return this.props.upsertGroup(group)
  }

  removeGroup(id) {
    this.props.removeGroup(id).then(() => {
      this.reload()
    })
  }

  search(query) {
    this.props.history.push(`/klanten?query=${query}`)
  }

  reload() {
    this.props.fetchCustomer(this.props.match.params.id)
  }

  render() {
    const { customer } = this.props
    if (customer && customer.id === -1) {
      return <NotFound />
    }
    if (isEmpty(customer) || customer.id !== parseInt(this.props.match.params.id, 10)) {
      return null
    }

    const groups = orderBy(customer.groups, ['id'], 'asc')

    return (
      <Grid>
        <Breadcrumbs title={customer.name} />
        <SearchBar
          placeholder="Zoek op klantnaam, product EAN of productnaam"
          callback={(query) => this.search(query)}
        />

        <Row>
          <div className="content">
            <div>
              <span className="title" data-customer-id={this.props.match.params.id}>
                <b>Klant</b>
              </span>
            </div>
            <div>
              <PropertyTitle icon="building-o" text={customer.name} />
              <Property icon="dot-circle-o" tooltipText="Klant UUID" value={customer.uuid} />
              <Property icon="file-text-o" tooltipText="NavisionCustomerId" value={customer.navisionCustomerId} />
              <br />
            </div>
            <div>
              <PropertyTitle small icon="users" text="Groepen" />
              <div className="tablescontainer">
                {groups.length > 0 ? (
                  <Table striped>
                    <thead>
                      <tr>
                        <th>Naam</th>
                        <th>Hoofdgroep</th>
                        <th />
                      </tr>
                    </thead>
                    <tbody>
                      {groups.map((group) => (
                        <tr className="group" key={group.id}>
                          <td onClick={() => this.props.history.push(`/groepen/${group.id}`)}>{group.name}</td>
                          <td onClick={() => this.props.history.push(`/groepen/${group.id}`)}>
                            {group.mainGroup ? 'Ja' : 'Nee'}
                          </td>
                          <td className="options">
                            {!group.mainGroup && (
                              <FontAwesome
                                className="delete"
                                name="trash"
                                size="lg"
                                onClick={() =>
                                  this.confirmModal.show(
                                    () => this.props.removeGroup(group.id),
                                    () => this.reload()
                                  )
                                }
                              />
                            )}
                            <FontAwesome
                              className="edit"
                              name="pencil"
                              size="lg"
                              onClick={() => this.groupModal.edit(group)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <p>Geen groepen</p>
                )}
                <FontAwesome
                  className="add-location add-group"
                  name="plus"
                  size="lg"
                  onClick={() => this.groupModal.add(customer)}
                />
              </div>
            </div>
            <LicenseTable history={this.props.history} licenses={customer.licenses} />
            <ConfirmHandleResponseModal
              ref={(ref) => (this.confirmModal = ref)}
              message="Weet je zeker dat je deze groep wilt verwijderen?"
            />
            <GroupModal
              ref={(ref) => (this.groupModal = ref)}
              reload={() => this.reload()}
              onSave={(group) => this.upsertGroup(group)}
            />
            <NotesOverview customer={customer} />
          </div>
        </Row>
      </Grid>
    )
  }
}

export default connect(
  (state) => {
    return {
      customer: state.customers.detail.customer,
    }
  },
  {
    fetchCustomer,
    upsertGroup,
    removeGroup,
  }
)(CustomerDetail)
